module.exports = __webpack_public_path__ + "img/adjust-grey56.4d9cda52.svg";